export default "__VITE_ASSET__DZ7FCk59__"